module.exports = __webpack_public_path__ + "static/img/passsz.2cdd8cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passsz.png
// module id = tYAd
// module chunks = 0